import { parseDate, parseTime } from "helpers/date";
import { parsePrice, centsToDollars } from "helpers/price";

import { StyledInsuranceContainer } from "../styled";

interface IInsuranceSection {
  name: string;
  deductible: number;
  outOfPocketMax: number;
  flatCopay: number;
  coinsurancePercent: number;
  isSecondary: boolean;
  benefitsUpdatedAt: string;
  orderCreatedDate: string;
}

function InsuranceSection({
  name,
  deductible,
  outOfPocketMax,
  flatCopay,
  coinsurancePercent,
  isSecondary,
  benefitsUpdatedAt,
  orderCreatedDate,
}: IInsuranceSection) {
  return (
    <StyledInsuranceContainer>
      <p className="text-xs font-medium">
        {isSecondary ? "SECONDARY INSURANCE DETAILS" : "INSURANCE DETAILS"}
      </p>
      <p className="highlighted font-semibold text-lg">
        Your Benefit Status{" "}
        <span className="text-xs font-normal light-gray">
          As of{" "}
          {benefitsUpdatedAt
            ? parseDate(benefitsUpdatedAt, true, true)
            : parseDate(orderCreatedDate, true, true)}
          ,{" "}
          {benefitsUpdatedAt
            ? parseTime(benefitsUpdatedAt, true)
            : parseTime(orderCreatedDate, true)}
        </span>
      </p>
      <div className="flex flex-column gap-1 p-2 gap-3">
        <div className="flex justify-content-between">
          <p className="text-sm font-normal gray-text">Insurance Name</p>
          <p className="text-sm font-medium gray-text">{name}</p>
        </div>
        <div className="flex justify-content-between">
          <p className="text-sm font-normal gray-text">Deductible Remaining</p>
          <p className="text-sm font-medium gray-text">
            {parsePrice(centsToDollars(deductible))}
          </p>
        </div>
        <div className="flex justify-content-between">
          <p className="text-sm font-normal gray-text">
            Remaining Out of Pocket
          </p>
          <p className="text-sm font-medium gray-text">
            {parsePrice(centsToDollars(outOfPocketMax))}
          </p>
        </div>
        <div className="flex justify-content-between">
          <p className="text-sm font-normal gray-text">Coinsurance Rate</p>
          <p className="text-sm font-medium gray-text">{coinsurancePercent}%</p>
        </div>
        {flatCopay ? (
          <div className="flex justify-content-between">
            <p className="text-sm font-normal gray-text">Flat Copay Rate</p>
            <p className="text-sm font-medium gray-text">
              {parsePrice(centsToDollars(flatCopay))}
            </p>
          </div>
        ) : null}
      </div>
    </StyledInsuranceContainer>
  );
}

export default InsuranceSection;
